var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Cursor } from "../events/cursor";
import { Input } from "../events/input";
import { Location } from "../events/location";
import { Observer } from "../events/observer";
import { Scroll } from "../events/scroll";
import { log } from "../../utils";
import { HighLighter } from "../events/highlight";
import { Sheet } from "../events/sheet";
import { PageBase, SIGNATURE_KEY } from "./base";
import { Filter } from "./filter";
import { Serializer } from "./serializer";
var RegistatrionState;
(function (RegistatrionState) {
    RegistatrionState[RegistatrionState["UNREGISTERED"] = 0] = "UNREGISTERED";
    RegistatrionState[RegistatrionState["REGISTERING"] = 1] = "REGISTERING";
    RegistatrionState[RegistatrionState["REGISTERED"] = 2] = "REGISTERED";
})(RegistatrionState || (RegistatrionState = {}));
export class Iframe extends PageBase {
    constructor(target, options) {
        super(target, null);
        this.target = target;
        this.isOwner = true;
        this.isRoot = false;
        this.registrationState = RegistatrionState.UNREGISTERED;
        this.allowedOrigins = ((options === null || options === void 0 ? void 0 : options.allowOrigins) || []).join("\n");
        this.observer = new Observer(this);
        this.serializer = new Serializer(this);
        this.input = new Input(this, (ev) => this.messenger.sendPageUpdate(this.event("InputUpdate", ev)));
        this.cursor = new Cursor(this, (ev) => this.messenger.sendPageUpdate(this.event("Cursor", ev)));
        this.scroll = new Scroll(this, (ev) => this.messenger.sendPageUpdate(this.event("ScrollUpdate", ev)));
        this.location = new Location(this, (ev) => {
            this.messenger.sendPageUpdate(this.event("Navigation", ev));
        });
        this.sheet = new Sheet(this, (ev) => {
            this.messenger.sendPageUpdate(this.event("SheetUpdate", ev));
        });
        this.highlighter = new HighLighter(this, (ev) => this.messenger.sendPageUpdate(this.event("HighLight", ev)));
        if (this.getWindow()[SIGNATURE_KEY])
            log("iframe constuctor, signature already assigned; new one", this.getWindow()[SIGNATURE_KEY], this.signature);
        this.getWindow()[SIGNATURE_KEY] = this.signature;
        this.messenger.sendStatusRequest();
    }
    // private log(...args: any[]) {
    //   console.warn(location.href, "IFRAME", this, ...args);
    // }
    /** window messages */
    onPleaseRegister(ev) {
        if (this.registrationState === RegistatrionState.UNREGISTERED) {
            this.registrationState = RegistatrionState.REGISTERING;
            this.messenger.sendRegistrationRequest(ev.id);
        }
    }
    onDocumentRegistered(ev) {
        var _a;
        this.registrationState = RegistatrionState.REGISTERED;
        this.documentId = ev.id;
        this.allowedOrigins += ((_a = ev.init.allowOrigins) === null || _a === void 0 ? void 0 : _a.join("\n")) || "";
        this.user = ev.init.user;
        this.options = Object.assign(Object.assign({}, ev.init), { allowOrigins: this.allowedOrigins.split("\n") });
        this.init();
    }
    init() {
        return __awaiter(this, void 0, void 0, function* () {
            log("Iframe initializing, origin;", this.href);
            this.getWindow().addEventListener("pagehide", () => {
                this.cleanup();
            }, {
                once: true,
            });
            if (this.getDocument().readyState !== "complete") {
                yield new Promise((resolve) => this.getWindow().addEventListener("load", resolve, { once: true }));
            }
            this.messenger.sendPageUpdate(this.event("Document", {
                id: this.documentId,
                target: this.options.targetId,
            }, this.options.parentId));
            this.filter = new Filter(this, this.options.filters || []);
            this.track();
        });
    }
    render(ev) {
        return __awaiter(this, void 0, void 0, function* () {
            switch (ev.type) {
                case "InputUpdate":
                    this.handleRemoteInput(ev);
                    break;
                case "ScrollUpdate":
                    this.handleRemoteScroll(ev);
                    break;
                case "Cursor":
                    this.handleRemoteCursor(ev);
                    break;
                case "HighLight":
                    yield this.highlighter.dispatch(ev.payload);
                    break;
            }
        });
    }
    requestAbsolutePosition() {
        this.messenger.sendAbsolutePositionRequest();
    }
    /** @param lite - merges events to form a page instance */
    flush() {
        return __awaiter(this, arguments, void 0, function* (lite = false) { });
    }
    track() {
        var _a;
        (_a = this.location) === null || _a === void 0 ? void 0 : _a.track();
        this.sheet.track();
        this.observer.track(this.getDocument().documentElement);
        this.animate.track();
    }
    createIframe(target, options) {
        return new Iframe(target, options);
    }
    cleanup(shallow = false) {
        var _a, _b;
        if (this.cleared) {
            return;
        }
        (_a = this.observer) === null || _a === void 0 ? void 0 : _a.untrack();
        (_b = this.serializer) === null || _b === void 0 ? void 0 : _b.cleanup();
        this.sheet.untrack();
        super.cleanup(shallow);
    }
}
//# sourceMappingURL=iframe.js.map